import React from 'react';
import { footerColumns, socialLinks } from '../data/siteNav';
export function SiteFooter() {
  return <footer className="w-full bg-brand-navy pb-24 pt-12 text-white md:pb-12" data-id="element-182" data-mp="3r7zmzju1qka7">
      <div className="mx-auto grid max-w-6xl grid-cols-2 gap-8 px-6 md:grid-cols-3 lg:grid-cols-6" data-id="element-183" data-mp="3mh9ie8tg2lgk">
        <div data-id="element-184" data-mp="3hipx8amoddp9">
          <h2 className="text-lg font-bold" data-id="element-185" data-mp="3hj7xrjgdee2z">Follow Us</h2>
          <ul className="mt-3 space-y-1.5" data-id="element-186" data-mp="3hglrdn57u4mc">
            {socialLinks.map(s => <li key={s} data-id="element-187" data-mp="3di5v0sn8vjw9"><a href="#" onClick={e => e.preventDefault()} className="text-xs text-white/90 hover:text-white hover:underline" data-id="element-188" data-mp="3dei31xxg75jn">{s}</a></li>)}
          </ul>
        </div>
        {footerColumns.map(col => <div key={col.title} data-id="element-189" data-mp="2yju28x2zsvad">
            <h2 className="text-lg font-bold" data-id="element-190" data-mp="2ykn87vu4ngrg">{col.title}</h2>
            <ul className="mt-3 space-y-1.5" data-id="element-191" data-mp="11r1z4bvxdf4v">
              {col.links.map(l => <li key={l} data-id="element-192" data-mp="11oxufrq7cc3j"><a href="#" onClick={e => e.preventDefault()} className="text-xs text-white/90 hover:text-white hover:underline" data-id="element-193" data-mp="wsgwy6x44lds">{l}</a></li>)}
            </ul>
          </div>)}
      </div>
      <p className="mx-auto mt-10 max-w-6xl px-6 text-xs text-white/70" data-id="element-194" data-mp="1aqhm7bkzc3p2">© 2026 i9 Sports® Corporation. All rights reserved.</p>
    </footer>;
}